if (!customElements.get("bambu-header-search")) {
  class BambuHeaderSearch extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController();
      this.activeSearch = null;
      this.trigger = null;
    }

    connectedCallback() {
      const { signal } = this.abortController;
      this.backdrop = this.querySelector(".bambu-header-search__backdrop");
      this.querySelectorAll('input[type="search"]').forEach((input) => {
        input.addEventListener("input", () => {
          input.closest(".header__search")?.classList.toggle("has-query", Boolean(input.value.trim()));
        }, { signal });
      });

      this.querySelectorAll(".header__search .search__button").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const search = button.closest("predictive-search") || button.closest(".header__search");
          const form = button.closest("form.search");
          const field = button.closest(".field");
          const input = search?.querySelector('input[type="search"]');
          const isCurrentSearchOpen = this.classList.contains("is-open") && this.trigger === button;

          if (isCurrentSearchOpen) {
            if (input?.value.trim()) {
              form?.requestSubmit();
            } else {
              input?.focus();
            }
            return;
          }

          form?.classList.add("active");
          field?.classList.add("shown");
          this.open(search, button);
          input?.focus();
        }, { capture: true, signal });
      });

      this.backdrop?.addEventListener("click", () => this.close(true), { signal });
      document.addEventListener("pointerdown", this.handleOutsideClick.bind(this), { signal });
      document.addEventListener("keydown", this.handleKeydown.bind(this), { signal });
      window.addEventListener("resize", this.updatePanelPosition.bind(this), { signal });
      window.addEventListener("scroll", this.updatePanelPosition.bind(this), { signal, passive: true });
    }

    disconnectedCallback() {
      this.abortController.abort();
      document.body.classList.remove("bambu-header-search-open");
    }

    open(search, trigger) {
      if (!search) return;

      document.querySelector("bambu-header-menu")?.closeAll?.();
      this.activeSearch = search;
      this.trigger = trigger;
      search.closest(".header__search")?.classList.toggle("has-query", Boolean(search.querySelector('input[type="search"]')?.value.trim()));
      this.classList.add("is-open");
      this.activeSearch.querySelectorAll("[data-bambu-search-popular]").forEach((element) => {
        element.removeAttribute("hidden");
      });
      this.backdrop?.removeAttribute("hidden");
      this.trigger.setAttribute("aria-expanded", "true");
      document.body.classList.add("bambu-header-search-open");
      this.updatePanelPosition();
    }

    close(restoreFocus = false) {
      if (!this.classList.contains("is-open")) return;

      const form = this.activeSearch?.querySelector("form.search");
      const field = this.activeSearch?.querySelector(".field");
      form?.classList.remove("active");
      field?.classList.remove("shown");

      if (typeof this.activeSearch?.close === "function") {
        this.activeSearch.close(false);
      }

      this.activeSearch?.querySelectorAll("[data-bambu-search-popular]").forEach((element) => {
        element.setAttribute("hidden", "");
      });

      this.classList.remove("is-open");
      this.backdrop?.setAttribute("hidden", "");
      this.trigger?.setAttribute("aria-expanded", "false");
      document.body.classList.remove("bambu-header-search-open");

      if (restoreFocus) this.trigger?.focus();
      this.activeSearch = null;
    }

    handleOutsideClick(event) {
      if (!this.classList.contains("is-open")) return;
      if (event.target.closest(".header__search")) return;
      this.close(false);
    }

    handleKeydown(event) {
      if (event.key !== "Escape" || !this.classList.contains("is-open")) return;
      event.preventDefault();
      this.close(true);
    }

    updatePanelPosition() {
      if (!this.classList.contains("is-open")) return;

      this.style.setProperty("--bambu-search-panel-top", "0px");
    }
  }

  customElements.define("bambu-header-search", BambuHeaderSearch);
}
